import { useConfigStore } from "@/store/config";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

export function formatTime(timestamp: string | Date): string {
  const { locale } = useConfigStore.getState();
  return dayjs(timestamp)
    .tz(locale === "en" ? "America/New_York" : "Asia/Shanghai")
    .format("YYYY-MM-DD HH:mm:ss");
}
